
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-study-guides",
      function () {
        return require("private-next-pages/ai-study-guides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-study-guides"])
      });
    }
  